/**
 * Format exercise title by replacing underscores with spaces and capitalizing properly
 */
export const formatExerciseTitle = (title: string): string => {
  if (!title) return "";

  // Replace underscores with spaces
  let formatted = title.replace(/_/g, " ");

  // Capitalize first letter of each word
  formatted = formatted
    .split(" ")
    .map((word) => {
      if (word.length === 0) return word;
      // Handle special cases like "Ubuntu", "Python", etc.
      const lower = word.toLowerCase();
      if (lower === "ubuntu" || lower === "linux") {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      }
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ");

  return formatted;
};
